// A client's prefix, as it is shown and as it is written into a project name:
// always upper case ("cdt" -> "CDT").
//
// Clients are stored however they were typed - some upper case, some not -
// but every project name built from one uses the upper-case form
// ("CDT-26001-PRO-001"), so showing the raw value made the same client read
// as two different ones depending on where you looked.
export const formatClientPrefix = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase();

// Whether two client references - a name or a prefix, against whatever the
// account was created with - mean the same client. Case-insensitive: a
// prefix is stored however it was typed (the client editor only settled on
// upper case later), so an exact match would hide a user's own projects.
export const isSameClientRef = (a, b) =>
  String(a ?? "")
    .trim()
    .toLowerCase() ===
  String(b ?? "")
    .trim()
    .toLowerCase();
